/** Line icons (24px grid, 2px stroke, round joins). Decorative by default; pass `label` when an icon stands alone. */
export const ICONS = {
  today: "M3 11l9-7 9 7v9a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1z",
  do: "M9 11l3 3 8-8M20 12v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h9",
  report: "M12 3l9.5 16.5h-19zM12 10v4.5M12 17.2v.3",
  paper: "M7 3h7l5 5v13H7zM14 3v5h5M10 13h6M10 17h6",
  camera: "M4 8h3l2-3h6l2 3h3v11H4zM12 17a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
  learn: "M4 5.5C6.5 4 9.5 4 12 5.5v14C9.5 18 6.5 18 4 19.5zM20 5.5C17.5 4 14.5 4 12 5.5v14c2.5-1.5 5.5-1.5 8 0z",
  people: "M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM2 21a7 7 0 0 1 14 0M16.5 3.3a4 4 0 0 1 0 7.4M22 21a7 7 0 0 0-4.5-6.5",
  prove: "M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6zM8.5 12l2.5 2.5 4.5-5",
  settings: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z",
  more: "M4 6h16M4 12h16M4 18h16",
  phone: "M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2",
  text: "M21 12a8 8 0 0 1-11.6 7.1L4 20.5l1.4-4.9A8 8 0 1 1 21 12z",
  bell: "M6 9a6 6 0 1 1 12 0c0 6 2.5 7.5 2.5 7.5h-17S6 15 6 9M10 20a2 2 0 0 0 4 0",
  pin: "M12 21s7-5.6 7-11.5A7 7 0 0 0 5 9.5C5 15.4 12 21 12 21zM12 12a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z",
  cart: "M3 4h2.5l2.2 11h10.6L21 7H7M10 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM17 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
  check: "M5 12.5l4.5 4.5L19 7.5",
  flag: "M5 21V4M5 4.5h12l-2.5 4 2.5 4H5",
  x: "M6 6l12 12M18 6L6 18",
  alert: "M12 8v5M12 16.5v.5M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18z",
  info: "M12 11v6M12 7.5v.5M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18z",
  clock: "M12 7v5l3 2M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18z",
  hands: "M7 11V6.5a1.5 1.5 0 0 1 3 0V11M10 10V5a1.5 1.5 0 0 1 3 0v5M13 10V6a1.5 1.5 0 0 1 3 0v6M16 11.5V9a1.5 1.5 0 0 1 3 0v4.5a7.5 7.5 0 0 1-7.5 7.5A6.5 6.5 0 0 1 5.8 17.6L3.6 13.8a1.5 1.5 0 0 1 2.6-1.5L7 13.5",
  search: "M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM20 20l-4-4",
  logout: "M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3M10 16l-4-4 4-4M6 12h10",
  chevron: "M9 6l6 6-6 6",
  back: "M15 6l-6 6 6 6",
  undo: "M9 14L4 9l5-5M4 9h10.5a5.5 5.5 0 0 1 0 11H11",
  thermo: "M14 14.8V5a2 2 0 1 0-4 0v9.8a4 4 0 1 0 4 0zM12 9v7",
  bug: "M8 9a4 4 0 0 1 8 0v5a4 4 0 0 1-8 0zM12 9v9M4 13h4M16 13h4M5 7l3 2M19 7l-3 2M5 19l3-2M19 19l-3-2M10 5L9 3M14 5l1-2",
  sick: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM8.5 10h.01M15.5 10h.01M8 16c1.2-1.3 2.5-2 4-2s2.8.7 4 2",
  customer: "M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 21a8 8 0 0 1 16 0M16.5 14.5l3-3",
  drop: "M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11z",
  bandage: "M4.5 14.5l10-10a3.5 3.5 0 0 1 5 5l-10 10a3.5 3.5 0 0 1-5-5zM10 10l4 4M11 12.5h.01M12.5 11h.01",
  wrench: "M14.7 6.3a4 4 0 0 0 5 5L21 13l-8 8-3-3 8-8M9.3 17.7L3 11.4a4 4 0 0 1 5-5",
  bolt: "M13 2L4 14h7l-1 8 9-12h-7z",
  flame: "M12 3c.8 3.2 5 5.2 5 10a5 5 0 0 1-10 0c0-2.2 1-3.6 2.2-4.8.3 1.6 1 2.4 2 2.6C10.6 8 11 5.6 12 3z",
  flask: "M9 3h6M10 3v6l-5 9a2 2 0 0 0 1.8 3h10.4A2 2 0 0 0 19 18l-5-9V3M7.5 15h9",
  allergen: "M12 21c-4-3-7-6.5-7-11a7 7 0 0 1 14 0c0 4.5-3 8-7 11zM9 10h6M12 7v6",
  plate: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
  dots: "M5 12h.01M12 12h.01M19 12h.01",
  restroom: "M7 21v-6H5l2-6h2l2 6H9v6M8 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM15 21V9h4v12M17 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
  download: "M12 3v12M7 10l5 5 5-5M4 19h16",
  printer: "M6 9V3h12v6M6 18H4v-7h16v7h-2M8 14h8v7H8z",
  calendar: "M4 6h16v14H4zM4 10h16M8 3v4M16 3v4",
  sun: "M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4",
  moon: "M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z",
  spark: "M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z",
  handoff: "M4 12h12M12 8l4 4-4 4M20 5v14",
  book: "M5 4h11a3 3 0 0 1 3 3v13H8a3 3 0 0 1-3-3zM5 17a3 3 0 0 1 3-3h11",
  plus: "M12 5v14M5 12h14",
  minus: "M5 12h14",
  trash: "M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3",
  box: "M3 7.5L12 3l9 4.5v9L12 21l-9-4.5zM3 7.5L12 12l9-4.5M12 12v9",
  /* An outside link (content kind "outside", DESIGN §3a): the page leaves the app. */
  external: "M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5",
  link: "M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1",
  wifi: "M2 8.5a15 15 0 0 1 20 0M5 12a10 10 0 0 1 14 0M8.5 15.5a5 5 0 0 1 7 0M12 19h.01M3 3l18 18",
  eye: "M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
  bluetooth: "M7 7l10 10-5 5V2l5 5L7 17",
  mic: "M12 3a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3zM5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21M8.5 21h7",
  /* Easy steps pictures (core easy.ts EasyIcon) */
  stop: "M8.3 3h7.4L21 8.3v7.4L15.7 21H8.3L3 15.7V8.3zM8 12h8",
  gloves: "M7 21v-5l-3-4.5a1.4 1.4 0 0 1 2.3-1.6L8 12V5a1.5 1.5 0 0 1 3 0v5M11 9V3.5a1.5 1.5 0 0 1 3 0V10M14 9.5V5a1.5 1.5 0 0 1 3 0v6M17 10a1.5 1.5 0 0 1 3 0v4a6 6 0 0 1-4 5.6V21H7",
  spray: "M9 9h6v12H9zM10 9V6h4v3M14 6h2l2-2M17 7h.01M20 6h.01M20 9h.01M18 10h.01",
  towel: "M6 3h12v12H6zM6 15v6h9v-6M6 7h12M9 11h6",
  soap: "M5 11h14v8a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2zM9 11V8h6v3M12 8V5h4M8 15h8",
  fridge: "M6 3h12v18H6zM6 10h12M9 6v2M9 13v3",
  // Thaw in the microwave (core FoodQuestion "thaw_method").
  microwave: "M3 6h18v12H3zM6 9h9v6H6zM18 9v.01M18 12v.01M18 15v.01",
  sign: "M5 4h14v10H5zM12 14v7M8 21h8M8 8h8M8 11h5",
  card: "M3 6h18v12H3zM3 10h18M7 15h4",
  write: "M4 20h4L19 9l-4-4L4 16zM13 7l4 4M14 20h6",
} as const;

export type IconName = keyof typeof ICONS;

export function Icon({ name, size = 22, label, className }: { name: IconName; size?: number; label?: string; className?: string }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}
      {...(label ? { role: "img", "aria-label": label } : { "aria-hidden": true })}>
      <path d={ICONS[name]} />
    </svg>
  );
}
